/**
 * Brand Icons
 * 
 * Third-party brand logos and integration icons.
 * 
 * Used by: OAuth integrations, cloud storage, external services
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGoogleDrive as fabGoogleDrive,
  faDropbox as fabDropbox,
  faGoogle as fabGoogle,
  faMicrosoft as fabMicrosoft,
} from "@fortawesome/free-brands-svg-icons";

export const loadBrandIcons = () => {
  library.add(
    fabGoogleDrive,
    fabDropbox,
    fabGoogle,
    fabMicrosoft,
  );
};
